import { IButtonIconProps } from "./interfaces";
import styles from "./styles";

export function ButtonIcon({ control }: IButtonIconProps) {
  return control ? <styles.ButtonIconWrapper onClick={control.handler}>{control.icon}</styles.ButtonIconWrapper> : null;
}
